import { render, staticRenderFns } from "./QuickTask.vue?vue&type=template&id=0164cf72&scoped=true&"
import script from "./QuickTask.vue?vue&type=script&lang=js&"
export * from "./QuickTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164cf72",
  null
  
)

export default component.exports